import React from "react";
import { HiOutlineMail } from "react-icons/hi";

export default function ForgotPasswordForm({
  email,
  setEmail,
  onSubmit,
  onBack,
  isLoading,
}) {
  return (
    <form className="space-y-6 w-full" onSubmit={onSubmit}>
      <div className="space-y-2">
        <label className="block text-slate-600 text-sm font-medium">Email</label>
        <div className="relative">
          <HiOutlineMail className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 h-5 w-5" />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full bg-white border border-slate-200 rounded-lg py-3 pl-12 pr-4 text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all"
            placeholder="mail@example.com"
            disabled={isLoading}
          />
        </div>
      </div>
      <div className="space-y-4">
        <button
          type="submit"
          className="w-full py-3 px-4 rounded-lg bg-indigo-600 text-white font-semibold shadow-sm hover:bg-indigo-700 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          disabled={isLoading}
        >
          {isLoading ? "Şifre Sıfırlanıyor..." : "Şifre Sıfırla"}
        </button>
        <button
          type="button"
          onClick={onBack}
          className="w-full text-sm text-indigo-600 hover:text-indigo-700 transition-colors"
          disabled={isLoading}
        >
          Giriş Sayfasına Dön
        </button>
      </div>
    </form>
  );
}
